﻿'use strict'
import { App, View } from '../../config/app.js'
import { getErrorCode, getErrorMessage, getPasswordErrors } from '../../helper.js'
import { Modal } from '../../modal.js'

export default async function ()
{
	App.Modal.PasswordChange = new Modal('PasswordChange', {
		viewPasswordRequirements: App.View.cache('partial/passwordRequirements') || new View('partial/passwordRequirements'),
		onOpen: modal =>
		{
			modal.options.viewPasswordRequirements.model.errors = []
			$('.password-strength-meter', modal.element).removeAttr('style')
		},
		onActionBefore: (modal, e) =>
		{
			// Get and display any password errors
			const pwChange = e.detail.data.passwordChange;
			modal.options.viewPasswordRequirements.model.errors = getPasswordErrors(pwChange.newPassword, pwChange.confirmNewPassword, pwChange.password)
			if (modal.options.viewPasswordRequirements.model.errors.length)
				e.preventDefault() // Cancel the event
		},
		onActionAfter: (modal, e) =>
		{
			if (!e.detail.success && getErrorCode(e) == 'wrong_password')
			{
				e.stopPropagation()
				const passwordInput = modal.element.querySelector('.modal-body [name="passwordChange[password]"]')
				passwordInput.setCustomValidity(getErrorMessage(e))
				passwordInput.reportValidity()
			}
		}
	})

	document.addEventListener('app.ready', () =>
	{
		const qs = new URLSearchParams(location.search)
		const changePassword = qs.get('changepassword')
		if (changePassword === 'true')
		{
			App.Store.fetch('topic', 'PasswordChangePolicy')
				.then(() =>
				{
					App.Modal.PasswordChange.open(
						() => { },
						err => console.error(err),
						null
					)
				})
				.catch(err => console.error(err))
		}
	})

}
